module.exports = __webpack_public_path__ + "img/slide14.490e71f3.jpg";